// src/components/HowItWorks.jsx
import React from 'react';
import buyIcon from '../assets/icons/info-cart.svg'
import planActivateIcon from '../assets/icons/list.svg'
import claimIcon from '../assets/icons/bank.svg'
import sarvamlogo from "../assets/sarvam.svg";
import magmaLogo from "../assets/magma-health-insurance-logo-web.png";
import '../HowItWorks.css';

const HowItWorks = ({ icons }) => {
    const inlineStyle = {
        display: 'inline',
        marginRight: '10px'
    };
    const linkClickHandler = (btn) => {
        const links = {
            'terms': 'https://drive.google.com/file/d/1XeKEIqVQYlNuEP0CCKozddu9ZrOiJg3P/view',
            'faq': 'https://drive.google.com/file/d/1Cg_veQV5-5RZkiaL97JN85LEQIeI5Bmh/view'
        }
        window.open(links[btn], '_blank', 'noopener,noreferrer');
    };
    return (
        <div className="how-it-works">
            <h2>How it works</h2>
            <div className="steps">
                <div className="step">
                    <img src={buyIcon} alt="Buy Plan" />
                    <div className="step-content">
                        <h3>Buy a plan for yourself or your family member</h3>
                        <p>Choose ₹500 or ₹1,000 daily coverage, we only ask for basic details to enroll</p>
                    </div>
                </div>
                <div className="step">
                    <img src={planActivateIcon} alt="Plan Activation" />
                    <div className="step-content">
                        <h3>Plan activates after 24 hours of admission</h3>
                        <p>You are eligible to claim for rest of the days equal to daily coverage chosen</p>
                    </div>
                </div>
                <div className="step">
                    <img src={claimIcon} alt="Claim" />
                    <div className="step-content">
                        <h3>Claim directly into your bank account post discharge</h3>
                        <p>Fill the claim form, attach the discharge summary and other documents. Email it to us and done!</p>
                    </div>
                </div>
            </div>
            <div className="faq-section">
                <h3 style={inlineStyle}>Have questions? We got answers-</h3>
                <a href="/faqs" style={inlineStyle} onClick={(e) => {
                    e.preventDefault(); 
                    linkClickHandler('faq');
                }}>View FAQs</a>
                <br />
            </div>
            <div className="logos">
                <img src={magmaLogo} alt="eKure Logo" />
                {/* <img src={sarvamlogo} alt="Magma Logo" /> */}
            </div>
            <a
                onClick={(e) => {
                    e.preventDefault();
                    linkClickHandler('terms');
                }}>Terms and conditions apply</a>
        </div>
    );
};

export default HowItWorks;
